import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import "@/veriauth.css";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Scan from "@/pages/Scan";
import Assessment from "@/pages/Assessment";
import AdminLogin from "@/pages/AdminLogin";
import Dashboard from "@/pages/Dashboard";
import Demo from "@/pages/Demo";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    let sid = sessionStorage.getItem("va_sid");
    if (!sid) {
      sid = window.crypto?.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
      sessionStorage.setItem("va_sid", sid);
    }
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/track`, { path: pathname, ref: document.referrer || "", sid }).catch(() => {});
  }, [pathname]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollTop />
      {!isAdmin && <Nav />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/scan" element={<Scan />} />
        <Route path="/assessment" element={<Assessment />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
};

function App() {
  useEffect(() => { document.body.classList.add("va-body"); }, []);
  return (
    <div className="va">
      <div className="va-blueprint" />
      <div className="grain" />
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll>
            <Shell />
          </SmoothScroll>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
